import SelectedIcon from '../../../../assets/icons/signup-selected.svg';

import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './QuickFileTab.less';

export type QuickFileTabValue = 'media' | 'audio';

interface QuickFileTabProps {
  onChange: (value: QuickFileTabValue) => void;
  initialValue?: QuickFileTabValue;
  disableMediaTab?: boolean;
  disableAudioTab?: boolean;
}

const QuickFileTab = ({ onChange, initialValue = 'media', disableMediaTab, disableAudioTab }: QuickFileTabProps) => {
  const { t } = useTranslation();
  const [selected, setSelected] = useState<QuickFileTabValue>(initialValue);

  const handleSwitchClick = (value: QuickFileTabValue) => {
    if (value === "media" && disableMediaTab) {
      return;
    }
    if (value === "audio" && disableAudioTab) {
      return;
    }
    setSelected(value);
    onChange(value);
  };
  
  const options: { key: QuickFileTabValue; label: string }[] = [
    { key: 'media', label: t('photos-videos') },
    { key: 'audio', label: t('audios') },
  ];

  return (
    <div className="quick-file-tab-wrapper">
      <div className="quick-file-switch-container">
        {options.map((opt) => (
          <div
            key={opt.key}
            className={`quick-file-switch ${selected === opt.key ? 'selected' : ''}`}
            onClick={() => handleSwitchClick(opt.key)}
            role="button"
            tabIndex={0}
            aria-pressed={selected === opt.key}
          >
            <div className="qf-switch-content">
              {selected === opt.key && <img src={SelectedIcon} className="qf-selected-icon" alt="Selected" />}
              <span className={`quick-file-switch-text ${selected === opt.key ? 'white' : ''}`}>{opt.label}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default QuickFileTab;
